import { APP_POOL_CONFIG } from '@synergy/config';
import { PoolLink } from '@synergy/components-next';
import { ReactElement } from 'react';

export const PhoneLink = (): ReactElement | null => {
    const phoneNumber = APP_POOL_CONFIG.phone;

    if (!phoneNumber) {
        return null;
    }

    return (
        <PoolLink colorVariant="primary2" underline="none" href={`tel:${phoneNumber}`}>
            {phoneNumber}
        </PoolLink>
    );
};
